export * from './configApplet';
export { default } from './configApplet';
